import { IDed } from 'gql/Request';
import { PaginationResult, SingletonResult } from 'gql/Common';
import Helper from 'utils/Helper';

export interface CreateMsEntraIDGroupTargetAccessInput {
  targetOrTargetGroupID: string;
  description: string;
  adGroups: string[];
  roleName: string;
}

export interface UpdateMsEntraIDGroupTargetAccessInput extends IDed, CreateMsEntraIDGroupTargetAccessInput {}

export interface MsEntraIDGroupTargetAccess extends IDed {
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  targetOrTargetGroupID: string;
  description: string;
  adGroups: string[];
  roleName: string;
}

export const MS_ENTRA_ID_GROUP_TARGET_ACCESS = `
{
  id
  createdBy
  createdAt
  updatedBy
  updatedAt
  targetOrTargetGroupID
  description
  adGroups
  roleName
}`;

const LIST_MS_ENTRA_ID_GROUP_TARGET_ACCESS = `
  query listMsEntraIDGroupTargetAccess($filter: TargetBoundAccessFilterInput, $pagination: PaginationInput) {
    listMsEntraIDGroupTargetAccess (filter: $filter, pagination: $pagination) {
      items ${MS_ENTRA_ID_GROUP_TARGET_ACCESS}
      total
      nextToken
    }
  }
`;

export interface GetMsEntraIDGroupTargetAccessOptions {
  id: string;
}

export interface ListMsEntraIDGroupTargetAccessOptions {
  targetOrTargetGroupID?: string;
  includeAllTargetGroups?: boolean;
  userADGroups?: string[];
  size?: number;
  nextToken?: string;
}

export const listMsEntraIDGroupTargetAccess = async (
  options?: ListMsEntraIDGroupTargetAccessOptions
): Promise<PaginationResult<MsEntraIDGroupTargetAccess>> => {
  const result = await Helper.execGQL<PaginationResult<MsEntraIDGroupTargetAccess>>({
    query: LIST_MS_ENTRA_ID_GROUP_TARGET_ACCESS,
    variables: {
      filter: {
        targetOrTargetGroupID: options?.targetOrTargetGroupID,
        includeAllTargetGroups: options?.includeAllTargetGroups,
        userADGroups: options?.userADGroups,
      },
      pagination: {
        size: options?.size,
        nextToken: options?.nextToken,
      },
    },
  });
  return result.listMsEntraIDGroupTargetAccess;
};

const GET_MS_ENTRA_ID_GROUP_TARGET_ACCESS = `
  query getMsEntraIDGroupTargetAccess($id: String!) {
    getMsEntraIDGroupTargetAccess(id: $id) {
      item ${MS_ENTRA_ID_GROUP_TARGET_ACCESS}
    }
  }`;

export const getMsEntraIDGroupTargetAccess = async (
  options: GetMsEntraIDGroupTargetAccessOptions
): Promise<MsEntraIDGroupTargetAccess> => {
  const result = await Helper.execGQL<SingletonResult<MsEntraIDGroupTargetAccess>>({
    query: GET_MS_ENTRA_ID_GROUP_TARGET_ACCESS,
    variables: {
      id: options.id,
    },
  });
  return result.getMsEntraIDGroupTargetAccess.item;
};

const CREATE_MS_ENTRA_ID_GROUP_TARGET_ACCESS = `
  mutation createMsEntraIDGroupTargetAccess($create: CreateMsEntraIDGroupTargetAccessInput!) {
    createMsEntraIDGroupTargetAccess(create: $create) {
      item {
        id
      }
    } 
  }`;

export const createMsEntraIDGroupTargetAccess = async (
  targetAccess: CreateMsEntraIDGroupTargetAccessInput
): Promise<IDed> => {
  const result = await Helper.execGQL<SingletonResult<MsEntraIDGroupTargetAccess>>({
    query: CREATE_MS_ENTRA_ID_GROUP_TARGET_ACCESS,
    variables: {
      create: targetAccess,
    },
  });
  return result.createMsEntraIDGroupTargetAccess.item;
};

const UPDATE_MS_ENTRA_ID_GROUP_TARGET_ACCESS = `
  mutation updateMsEntraIDGroupTargetAccess($update: UpdateMsEntraIDGroupTargetAccessInput!) {
      updateMsEntraIDGroupTargetAccess(update: $update) {
          item { 
              id
          }
      }
  }`;

export const updateMsEntraIDGroupTargetAccess = async (
  targetAccess: UpdateMsEntraIDGroupTargetAccessInput
): Promise<IDed> => {
  const result = await Helper.execGQL<SingletonResult<MsEntraIDGroupTargetAccess>>({
    query: UPDATE_MS_ENTRA_ID_GROUP_TARGET_ACCESS,
    variables: {
      update: targetAccess,
    },
  });
  return result.updateMsEntraIDGroupTargetAccess.item;
};

const DELETE_MS_ENTRA_ID_GROUP_TARGET_ACCESS = `
mutation deleteMsEntraIDGroupTargetAccess($id: String!) {
  deleteMsEntraIDGroupTargetAccess(id: $id) {
      item {
          id
      }
  }
} `;

export const deleteMsEntraIDGroupTargetAccess = async (id: string): Promise<IDed> => {
  const result = await Helper.execGQL<SingletonResult<MsEntraIDGroupTargetAccess>>({
    query: DELETE_MS_ENTRA_ID_GROUP_TARGET_ACCESS,
    variables: {
      id,
    },
  });
  return result.deleteMsEntraIDGroupTargetAccess.item;
};
